import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'RequestSigninDetailsEmail' })({
  input: {
    background: 'initial',
    backgroundColor: 'white',
  },
});
